/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */

export { AbstractImageQuantizer } from './imageQuantizer';
export { ImageQuantizerYieldValue } from './imageQuantizerYieldValue';
export { NearestColor } from './nearestColor';
export { ErrorDiffusionArray, ErrorDiffusionArrayKernel } from './array';
export { ErrorDiffusionRiemersma } from './riemersma';
